module.exports = __webpack_public_path__ + "img/cleaf1.9a23b5a4.jpg";